import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const inlineSuggestionPluginKey = new PluginKey('aiInlineSuggestion');
